import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { partnerRows, PartnerItem } from "src/libs/portal/season/partner";

declare var kakao: any;

interface SolutionCard {
    key: string;
    name: string;
    path: string;
    i18nKey: string;
    icon: string;
    eyebrow: string;
    visualType: 'image' | 'oedix';
    image?: string;
    tone: string;
    tags: string[];
}

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
}

:host *,
:host *::before,
:host *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}

/* ========================================
   HERO SECTION
   ======================================== */
.hero-section {
  position: relative;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #0C0A09 0%, #1C1917 40%, #0C0A09 100%);
  z-index: 0;
}

.hero-mesh-1,
.hero-mesh-2,
.hero-mesh-3 {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.4;
}

.hero-mesh-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, #FE5A33 0%, transparent 70%);
  top: -10%;
  right: -5%;
}

.hero-mesh-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, #FF8A65 0%, transparent 70%);
  bottom: -15%;
  left: -10%;
}

.hero-mesh-3 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #FE5A33 0%, transparent 70%);
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.2;
}

/* Grid overlay */
.hero-grid-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 50%, black 30%, transparent 80%);
  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 50%, black 30%, transparent 80%);
}

/* Badge */
.hero-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 18px;
  border-radius: 100px;
  background: rgba(254, 90, 51, 0.1);
  border: 1px solid rgba(254, 90, 51, 0.2);
  color: #FE5A33;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.2;
  white-space: nowrap;
}
.hero-badge i,
.hero-badge span {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  white-space: nowrap;
}
.hero-badge i {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  justify-content: center;
  font-size: 16px;
}

.hero-title {
  margin: 0;
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 56px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.12;
}

/* Bottom glow */
.hero-bottom-glow {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(254, 90, 51, 0.5), transparent);
  z-index: 10;
}
.hero-bottom-glow::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 10%;
  right: 10%;
  height: 80px;
  background: radial-gradient(ellipse at bottom, rgba(254, 90, 51, 0.08) 0%, transparent 70%);
}

/* Hero CTA Buttons */
.hero-cta-primary {
  display: inline-flex;
  align-items: center;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #FE5A33, #FF8A65);
  border-radius: 12px;
  text-decoration: none;
  white-space: nowrap;
}
.hero-cta-primary:hover {
  box-shadow: 0 8px 24px rgba(254, 90, 51, 0.35);
}

.hero-cta-secondary {
  display: inline-flex;
  align-items: center;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  text-decoration: none;
  backdrop-filter: blur(8px);
  white-space: nowrap;
}
.hero-cta-secondary:hover {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.35);
}

/* ========================================
   MISSION SECTION
   ======================================== */
.mission-section {
  background: linear-gradient(180deg, #0C0A09 0%, #1C1917 100%);
  color: #fff;
}

/* ========================================
   SOLUTIONS SECTION
   ======================================== */
.solutions-section {
  background: #fff;
}

.solution-card-grid {
  align-items: stretch;
}

.solution-card {
  display: flex;
  min-height: 398px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 18px 42px rgba(24, 24, 27, 0.06);
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
}
.solution-card:hover, .solution-card:focus-visible {
  border-color: rgba(254, 90, 51, 0.38);
  box-shadow: 0 24px 54px rgba(24, 24, 27, 0.12);
  transform: translateY(-4px);
  outline: none;
}
.solution-card:hover .solution-shot, .solution-card:focus-visible .solution-shot {
  transform: scale(1.04);
}
.solution-card:hover .solution-meta i, .solution-card:focus-visible .solution-meta i {
  transform: translateY(-1px);
}

.solution-visual {
  position: relative;
  height: 158px;
  overflow: hidden;
  border-bottom: 1px solid #e4e4e7;
  background: #f4f4f5;
}

.solution-shot {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.32s ease;
}

.tone-reviewops .solution-shot {
  object-position: 18% 12%;
}

.tone-dizest .solution-shot {
  object-position: 50% 26%;
}

.tone-wiz .solution-shot {
  object-position: 50% 50%;
}

.tone-works .solution-shot {
  object-position: 50% 50%;
}

.solution-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 18px;
}
.solution-body h3 {
  margin: 18px 0 9px;
  color: #18181b;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  word-break: keep-all;
  overflow-wrap: normal;
}
.solution-body p {
  min-height: 82px;
  margin: 0;
  color: #52525b;
  font-size: 16px;
  line-height: 1.62;
}

.solution-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.solution-meta i {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff3ef;
  color: #FE5A33;
  font-size: 18px;
  transition: transform 0.22s ease;
}

.solution-eyebrow {
  color: #71717a;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
  text-transform: uppercase;
}

.solution-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: auto;
  padding-top: 18px;
}
.solution-tags span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}

.tone-reviewops .solution-meta i,
.tone-reviewops .solution-tags span {
  color: #2563eb;
  background: #eff6ff;
}

.tone-dizest .solution-meta i,
.tone-dizest .solution-tags span {
  color: #4f46e5;
  background: #eef2ff;
}

.tone-wiz .solution-meta i,
.tone-wiz .solution-tags span {
  color: #059669;
  background: #ecfdf5;
}

.tone-works .solution-meta i,
.tone-works .solution-tags span {
  color: #ca8a04;
  background: #fefce8;
}

.oedix-mock {
  height: 100%;
  padding: 14px;
  background: linear-gradient(135deg, rgba(254, 90, 51, 0.22), rgba(254, 90, 51, 0) 38%), linear-gradient(135deg, #171717 0%, #27272a 100%);
}

.oedix-window {
  height: 100%;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(12, 10, 9, 0.56);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.oedix-window-head {
  display: flex;
  gap: 5px;
  padding: 10px 11px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.oedix-window-head span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.42);
}
.oedix-window-head span:first-child {
  background: #FE5A33;
}

.oedix-flow {
  display: grid;
  grid-template-columns: 1fr 18px 1fr 18px 1fr;
  align-items: center;
  gap: 6px;
  height: calc(100% - 28px);
  padding: 14px 12px 16px;
}

.oedix-node {
  min-width: 0;
  padding: 10px 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
}
.oedix-node strong,
.oedix-node span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.oedix-node strong {
  color: #fff;
  font-size: 16px;
  line-height: 1.2;
}
.oedix-node span {
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.56);
  font-size: 16px;
}
.oedix-node.is-active {
  border-color: rgba(254, 90, 51, 0.54);
  background: rgba(254, 90, 51, 0.18);
}

.oedix-link {
  height: 2px;
  border-radius: 1px;
  background: linear-gradient(90deg, rgba(254, 90, 51, 0.15), rgba(254, 90, 51, 0.9));
}

/* ========================================
   PARTNERSHIP SECTION
   ======================================== */
.partnership-section {
  background: linear-gradient(180deg, #0C0A09 0%, #18181B 100%);
  color: #fff;
}

.partner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 18px;
}

.partner-logo {
  min-height: 96px;
}

.partner-logo:hover,
.partner-logo:focus-within {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.partner-logo-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  outline: none;
}

.partner-logo-link:focus-visible {
  box-shadow: 0 0 0 3px rgba(254, 90, 51, 0.35);
}

/* ========================================
   LOCATION SECTION
   ======================================== */
.location-section {
  background: #fff;
}

/* ========================================
   RESPONSIVE
   ======================================== */
@media (max-width: 767px) {
  .hero-section {
    min-height: 100vh;
  }
  .hero-mesh-1 {
    width: 300px;
    height: 300px;
  }
  .hero-mesh-2 {
    width: 250px;
    height: 250px;
  }
  .hero-mesh-3 {
    width: 200px;
    height: 200px;
  }
  .hero-title {
    font-size: 36px;
    line-height: 1.18;
  }
}`],
})
export class PageMainComponent implements OnInit {
    @ViewChild('mapsContainer') mapsElement: ElementRef;

    public partnerData: any = {};
    public partnerError = false;
    public get partners(): PartnerItem[] {
        return partnerRows(this.partnerData, this.service.lang.get() || 'ko');
    }
    private mapInitialized = false;
    private readonly mapLatitude = 36.48409755878336;
    private readonly mapLongitude = 127.25900153533746;
    private readonly googleMapsUrl = 'https://goo.gl/maps/FLDWVrWR15ozbwdX9';


    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
        await this.loadPartners();
        await this.service.render();
        setTimeout(() => this.initMap(), 0);
    }

    private async loadPartners() {
        try {
            const res = await wiz.call('partner');
            this.partnerError = res?.code !== 200;
            this.partnerData = this.partnerError ? {} : res.data;
        } catch (e) {
            this.partnerError = true;
            this.partnerData = {};
        }
    }

    public initMap(): boolean {
        const container = this.mapsElement?.nativeElement as HTMLElement;
        if (!container) return false;
        if (this.mapInitialized) return true;

        if (typeof kakao === 'undefined' || !kakao.maps) {
            this.renderMapFallback(container);
            this.mapInitialized = true;
            return true;
        }

        try {
            container.innerHTML = '';
            const position = new kakao.maps.LatLng(this.mapLatitude, this.mapLongitude);
            new kakao.maps.StaticMap(container, {
                center: position,
                level: 3,
                marker: { position: position }
            });
            this.mapInitialized = true;
            return true;
        } catch (e) {
            this.renderMapFallback(container);
            this.mapInitialized = true;
            return true;
        }
    }

    private renderMapFallback(container: HTMLElement) {
        container.innerHTML = '';

        const iframe = document.createElement('iframe');
        iframe.title = 'SEASON location map';
        iframe.src = `https://www.google.com/maps?q=${this.mapLatitude},${this.mapLongitude}&z=16&output=embed`;
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = '0';
        iframe.style.display = 'block';

        container.appendChild(iframe);
    }

    public openGoogleMaps() {
        window.open(this.googleMapsUrl, '_blank');
    }

    public solutions: SolutionCard[] = [
        {
            key: 'oedix',
            name: 'OEDIX',
            path: '/solutions/oedix',
            i18nKey: 'main.oedix',
            icon: 'icon-brain-circuit',
            eyebrow: 'Next-gen Orchestration',
            visualType: 'oedix',
            tone: 'tone-oedix',
            tags: ['Task Queue', 'Harness']
        },
        {
            key: 'reviewops',
            name: 'ReviewOps',
            path: '/solutions/reviewops',
            i18nKey: 'main.reviewops',
            icon: 'icon-clipboard-check',
            eyebrow: 'Review Workflow',
            visualType: 'image',
            image: '/assets/solution/reviewops-screen.png',
            tone: 'tone-reviewops',
            tags: ['Evidence', 'QA']
        },
        {
            key: 'dizest',
            name: 'DIZEST',
            path: '/solutions/dizest',
            i18nKey: 'main.dizest',
            icon: 'icon-workflow',
            eyebrow: 'Research Workflow',
            visualType: 'image',
            image: '/assets/solution/dizest-screen.gif',
            tone: 'tone-dizest',
            tags: ['Flow Chart', 'AI Lab']
        },
        {
            key: 'wiz',
            name: 'WIZ',
            path: '/solutions/wiz',
            i18nKey: 'main.wiz',
            icon: 'icon-code-2',
            eyebrow: 'Web IDE',
            visualType: 'image',
            image: '/assets/solution/wiz-cover.jpg',
            tone: 'tone-wiz',
            tags: ['Builder', 'Plugin']
        },
        {
            key: 'works',
            name: 'SEASON Works',
            path: '/solutions/works',
            i18nKey: 'main.works',
            icon: 'icon-kanban',
            eyebrow: 'Collaboration',
            visualType: 'image',
            image: '/assets/solution/works-screen.jpg',
            tone: 'tone-works',
            tags: ['Project', 'Message']
        }
    ];

    public navigateTo(path: string) {
        this.service.href(path);
    }
}

export default PageMainComponent;